const Prop65 = (props) => {
  const { cart } = props;
  if (cart.shipTo && cart.shipTo.stateCode === 'CA') {
    return (
      <div className="c7-prop65">
        <p>
          WARNING: Drinking distilled spirits, beer, coolers, wine and other
          alcoholic beverages may increase cancer risk, and, during pregnancy,
          can cause birth defects. For more information go to{' '}
          <a
            href="https://www.P65Warnings.ca.gov/alcohol"
            rel="noopener noreferrer"
            target="_blank"
          >
            www.P65Warnings.ca.gov/alcohol
          </a>
          .
        </p>
      </div>
    );
  }
  return null;
};

export default Prop65;
